import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { UniverseComponent } from 'src/domains/common/universes';
import {
    OverlayDefault,
    Content,
    PopupHeader,
    PopupDescription,
    AcceptBtnContact,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import { ContactPreferencesNewState } from 'src/domains/players/webview/components/Account/preferencesTab/contactPreferencesNew/ContactPreferencesNew.state';
import { OffersSettingsNew } from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/createAccount/yourDetails/offersSettingsNew/OffersSettingsNew';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface BlockingKycNotificationType {
    onConfirm: () => Promise<void>;
}

export const BlockingContactPreferencesNotification = observer(
    'BlockingContactPreferencesNotification',
    ({ onConfirm }: BlockingKycNotificationType): JSX.Element | null => {
        const common = useCommon();
        const { contactPreferencesCategories } = ConfigComponents.get(common).config;
        const id = common.session.userId;
        const [contactPreferences] = useState(() => new ContactPreferencesNewState(common));
        const basicData = BasicDataModel.get(common);
        const data = basicData.basicDataReady;

        const email = data?.contactPreferencesByCategory?.find((item) => item.type === 'email');
        const phone = data?.contactPreferencesByCategory?.find((item) => item.type === 'phone');
        const sms = data?.contactPreferencesByCategory?.find((item) => item.type === 'sms');

        const state = contactPreferences.offersContactPreferencesNewStateAuto.get([
            email?.categories ?? [],
            phone?.categories ?? [],
            sms?.categories ?? [],
        ]);
        const handleChangeContactPreferences = async (): Promise<void> => {
            try {
                await contactPreferences.submitContactPreferences(id, state);
                await onConfirm();
            } catch {
                console.error('handleChangeContactPreferences');
            }
        };

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>

                    <PopupHeader>
                        <I18n
                            langKey='account.contact-preferences.title'
                            defaultText='Choose how you receive marketing'
                        />
                    </PopupHeader>
                    <PopupDescription>
                        <I18n
                            langKey='account.contact-preferences.description-part-2'
                            defaultText='Receive updates on exclusive offers, free bets & free spins by product and communication method.'
                        />
                    </PopupDescription>

                    <OffersSettingsNew
                        state={state}
                        contactPreferencesCategories={contactPreferencesCategories}
                        haveHeader={false}
                        additionalContainer={true}
                    />

                    <AcceptBtnContact
                        onClick={handleChangeContactPreferences}
                        size='medium'
                    >
                        <I18n
                            langKey='account.contact-preferences.confirm-button.label'
                            defaultText='Confirm'
                        />
                    </AcceptBtnContact>
                </Content>
            </OverlayDefault>
        );
    }
);
